module.exports = __webpack_public_path__ + "img/home-inactive.43e87305.png";